export default "__VITE_ASSET__7b8cf0f4__"